export default {
  rowsPerPage: 20,
  rowsPerPageOptions: [5, 10, 20, 50, 100],
  print: false,
  download: false,
  textLabels: {
    body: {
      noMatch: 'داده ای یافت نشد!',
      toolTip: 'مرتب سازی',
      columnHeaderTooltip: (column) => `مرتب سازی ${column.label}`,
    },
    pagination: {
      next: 'صفحه بعد',
      previous: 'صفحه قبل',
      rowsPerPage: 'سطر در صفحه:',
      displayRows: 'از',
    },
    toolbar: {
      search: 'جستجو',
      downloadCsv: 'دانلوذ CSV',
      print: 'چاپ',
      viewColumns: 'نمایش ستون ها',
      filterTable: 'فیلتر',
    },
    filter: {
      all: 'همه',
      title: 'فیلترها',
      reset: 'بازنشانی',
    },
    viewColumns: {
      title: 'نمایش ستون ها',
      titleAria: 'نمایش یا مخفی کردن ستون ها',
    },
    selectedRows: {
      text: 'سطر انتخاب شده',
      delete: 'حذف',
      deleteAria: 'حذف سطر های انتخاب شده',
    },
  },
}
